/**
* DevExpress HTML/JS Reporting (designer\internal\_getClosestDataMember.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export function getClosestDataMember(control) {
    while (control && !control['dataSource'] && !control['dataMember']) {
        control = control.parentModel();
    }
    return control['dataMember'] && control['dataMember']();
}
